var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTiff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "35px",
    viewBox: "0 0 27 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-0qj24vbphd-1",
    points: "-1.16348446e-16 34.5681485 26.8244942 34.5681485 26.8244942 1.60982339e-15 -1.16348446e-16 1.60982339e-15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tiff",
    transform: "translate(0.000105, 0.346535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-0qj24vbphd-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-0qj24vbphd-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1431597,8.06316832 L21.7967757,8.06316832 L19.372006,8.06316832 C18.9957727,8.06316832 18.6906716,7.76064357 18.6906716,7.38777228 L18.6906716,0.675396039 C18.6906716,0.673316831 18.6906716,0.671584158 18.6906716,0.66950495 L18.6906716,1.60982339e-15 L0.681334481,1.60982339e-15 C0.305101162,1.60982339e-15 -1.16348446e-16,0.302524752 -1.16348446e-16,0.675396039 L-1.16348446e-16,33.8924753 C-1.16348446e-16,34.2656931 0.305101162,34.5682179 0.681334481,34.5682179 L26.1431597,34.5682179 C26.519393,34.5682179 26.8244942,34.2656931 26.8244942,33.8924753 L26.8244942,8.06316832 L26.1431597,8.06316832 Z",
    id: "Fill-1",
    fill: "#AC8E68",
    fillRule: "nonzero",
    mask: "url(#mask-0qj24vbphd-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#AC8E68",
    fillRule: "nonzero",
    points: "20.0534451 0.395707742 20.0534451 6.71234141 26.4253521 6.71234141"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TIFF",
    fontFamily: "SFProRounded-Semibold, SF Pro Rounded",
    fontSize: 8,
    fontWeight: 500,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.69872352,
    y: 28.6534652
  }, "TIFF"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiff);
export default __webpack_public_path__ + "static/media/icon-tiff.129d7b8a3712dd8f5f1847c333489174.svg";
export { ForwardRef as ReactComponent };